@if (resourceDef && value) {<dhs-data-grid [data]="value" [fields]="resourceDef" [config]="config"></dhs-data-grid>}